var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseCercle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9453_3127)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#4D4D4D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 41.5V63.1667C48 66.759 45.0923 69.6667 41.5 69.6667C37.9077 69.6667 35 66.759 35 63.1667V41.5C35 37.9077 37.9077 35 41.5 35C45.0923 35 48 37.9077 48 41.5ZM69.6667 41.5V63.1667C69.6667 66.759 66.759 69.6667 63.1667 69.6667C59.5743 69.6667 56.6667 66.759 56.6667 63.1667V41.5C56.6667 37.9077 59.5743 35 63.1667 35C66.759 35 69.6667 37.9077 69.6667 41.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9453_3127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCercle);
export default __webpack_public_path__ + "static/media/pause-cercle.ea1ba957102358558f84f8d8a694af9b.svg";
export { ForwardRef as ReactComponent };